import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzGridModule } from 'ng-zorro-antd/grid';

@Component({
  selector: 'wilson-bulk-qualifications-footer-section',
  imports: [NzButtonModule, TranslatePipe, NzGridModule],
  templateUrl: './bulk-qualifications-footer-section.component.html',
  styleUrl: './bulk-qualifications-footer-section.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkQualificationsFooterSectionComponent {
  @Input() cancelTranslationKey = 'general.cancel';
  @Input() saveTranslationKey = 'general.save';

  @Input() saveButtonDisabled = false;
  @Input() loading: boolean | null = false;

  @Output() cancelDrawer = new EventEmitter<void>();
  @Output() saveDrawer = new EventEmitter<void>();

  protected cancelDrawerAction(): void {
    this.cancelDrawer.emit();
  }

  protected saveDrawerAction(): void {
    this.saveDrawer.emit();
  }
}
